export const readerDocsData = [
  {
    slug: "101-welcome-outline",
    title: "Welcome Outline ",  
    miniTitles: [
      { title: "Introduction", page: 0 }, 
      { title: "Chart Patterns", page: 1 },
      { title: "Japanese Candlestick Patterns", page: 2 },
      { title: "Fibonacci Trading", page: 3 },
    ],
    level: 100,
    subject: "Welcome Outline", // optional: could be used for sidebar grouping
  },
  {
    slug: "cryptocurrency-fundamentals",
    title: "Cryptocurrency Fundamentals",
    miniTitles: [
      { title: "Introduction", page: 1 },
      { title: "Stablecoins", page: 3 },
      { title: "Blockchain", page: 6},
      { title: "Mining", page: 7},
      { title: "Staking", page: 8},
      { title: "Coins and Tokens", page: 9},
      { title: "Forks", page: 10},
      { title: "Cryptocurrencies", page: 12}
    ],
    level: 500,
    subject: "Cryptocurrency Fundamentals",
  },
  {
    slug: "advanced-technical-analysis",
    title: "Advanced Technical Analysis ",
    miniTitles: [
      { title: "Introduction", page: 1 },
      { title: "Chart Patterns", page: 3 },
      { title: "Japanese Candlestick Patterns", page: 9},
      { title: "Fibonacci Trading", page: 23}
    ],
    level: 700,
    subject: "Advanced Technical Analysis",
  },
  // ... more docs
];
